const BACKEND_URL = process.env.SUBSCRIPTION_API_URL;

export const getSellingPlanIdApi = async (
  deliveryDate: string
): Promise<string> => {
  const response = await fetch(
    `${BACKEND_URL}/selling-plans/id?deliveryDate=${deliveryDate}`,
    {
      method: "GET",
      mode: "cors",
      cache: "no-cache",
      credentials: "same-origin",
      headers: {
        "content-type": "application/json",
      },
    }
  );
  return (await response.json()).id;
};
